<script>
import UiLoading from '../ui/Loading';
import { store } from '../../functions/mixins';
import * as sdk from '../../functions/sdk';

export default {
    mixins: [store],
    components: {
        UiLoading,
    },
    created() {
        const {
            token,
            recipientList,
        } = this.$route.query;
        if (!token) {
            this.$router.push({name: 'home'});
            return;
        }
        this.logout().then(() => {
            sdk.accessManagement.loginWithTokenEx(token).then(() => {
                sdk.pressengerControl.getUserInfo().then(uinfo => {
                    if (recipientList) {
                        sdk.setRecipientList(recipientList);
                    }
                    this.setUserInfo(uinfo);
                    this.$router.push({name: 'home'});
                });
            }).catch(() => {
                this.$router.push({name: 'home'});
            });
        });
    },
};
</script>

<template>
    <ui-loading />
</template>
